import { CHDataActionPayload, CHSuccessActionResult } from "@app/root-store/actions";
import { throwError } from "rxjs";

export class DataServiceError<T> {
    constructor(public error: any, public requestData?: T) {}

    public static handleError<T2>(requestData?: T2) {
        return result => {
            const error = new DataServiceError(result.error || result, requestData);
            return throwError(() => error);
        };
    }

    public static throwNonObservableError<T3>(requestData?: T3) {
        return result => {
            throw new DataServiceError(result.error || result, requestData);
        };
    }
}

export class CHDataServiceError<T> {
    public result;
    public uuid: string;

    constructor(public error: any, requestData?: CHSuccessActionResult<T> | CHDataActionPayload) {
        this.result = CHDataServiceError.getResult<T>(requestData);
        this.uuid = requestData.uuid;
    }

    public static getResult<T2>(requestData: CHSuccessActionResult<T2> | CHDataActionPayload) {
        const dataError = requestData as CHDataActionPayload;
        const resultError = requestData as CHSuccessActionResult<T2>;

        if (resultError) {
            return resultError.result;
        }

        return dataError;
    }

    public static handleError<T3>(requestData: CHSuccessActionResult<T3> | CHDataActionPayload) {
        return result => {
            const error = new DataServiceError(result.error || result, this.getResult(requestData));
            return throwError(() => error);
        };
    }
}
